import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * A native `<select>`. Deliberately not a listbox widget: §9 requires keyboard
 * navigation and WCAG AA, and the platform control gets both for free —
 * including on the phone, where the quick-log lives.
 */
const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-2 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';

export { Select };
